import { render, staticRenderFns } from "./ProblemComment.vue?vue&type=template&id=06d0a2e7&scoped=true"
import script from "./ProblemComment.vue?vue&type=script&lang=js"
export * from "./ProblemComment.vue?vue&type=script&lang=js"
import style0 from "./ProblemComment.vue?vue&type=style&index=0&id=06d0a2e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0a2e7",
  null
  
)

export default component.exports